import { render, staticRenderFns } from "./BaseLayoutWithHeaderAndSideBar.vue?vue&type=template&id=c0da0838&"
import script from "./BaseLayoutWithHeaderAndSideBar.vue?vue&type=script&lang=js&"
export * from "./BaseLayoutWithHeaderAndSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports